package pwgs.ui.scenes.allowedversionsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AAllowedVersionsControllerFe(props: pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps, scene: MAllowedVersionsScene)
 : AController<pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps, pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel, AllowedVersionsSceneState>(props, scene) {

    val backend = AllowedVersionsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_addVersion() {
        launchOnDefaultControllerScope {
            render(backend.addVersion())
        }
    }

    fun call_deleteVersion(ver: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.deleteVersion(ver))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class AllowedVersionsControllerBeProxy(private val controller: AAllowedVersionsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.allowedversionsscene.AllowedVersionsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer())
        }
    }

    suspend fun addVersion(): pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.allowedversionsscene.AllowedVersionsControllerBe.addVersion",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer())
        }
    }

    suspend fun deleteVersion(ver: kotlin.String): pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel {
        @Serializable
        class ParamsWrapper(val ver: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(ver))
        val p = RmiParams(
            action = "pwgs.ui.scenes.allowedversionsscene.AllowedVersionsControllerBe.deleteVersion",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.allowedversionsscene.AllowedVersionsSceneModel.serializer())
        }
    }

}
